import React from 'react';

export default props => (
  <i className="fa fa-spinner fa-spin fa-2x" />
);
